import { render, staticRenderFns } from "./FlaggedListingsView.vue?vue&type=template&id=dd8334ea&"
import script from "./FlaggedListingsView.vue?vue&type=script&lang=js&"
export * from "./FlaggedListingsView.vue?vue&type=script&lang=js&"
import style0 from "./FlaggedListingsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports